import { render, staticRenderFns } from "./BaseTextTooltip.vue?vue&type=template&id=42aca5fe"
import script from "./BaseTextTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTextTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports